/**
 * Resolves slot props that may be an object or a function of owner state (MUI-compatible).
 */
export function resolveComponentProps<T>(
  props: T | ((state: unknown) => T) | undefined,
  ownerState: unknown
): T | undefined {
  if (props === undefined) return undefined;
  if (typeof props === 'function') {
    return (props as (state: unknown) => T)(ownerState);
  }
  return props;
}
